export default __webpack_public_path__ + "static/media/fa-brands-400.5f363d3d.svg";